/**
 * Below lg the sidebar collapses into a top bar; the toggle opens its panel.
 */
export function initSidebar() {
	document.querySelectorAll("[data-amp-sidebar]").forEach((sidebar) => {
		const toggle = sidebar.querySelector("[data-amp-sidebar-toggle]");
		const logoutTrigger = sidebar.querySelector("[data-amp-logout-trigger]");
		const logoutDialog = sidebar.querySelector("[data-amp-logout-dialog]");
		const logoutCancel = sidebar.querySelector("[data-amp-logout-cancel]");
		if (!toggle) return;

		const setOpen = (open) => {
			sidebar.classList.toggle("is-open", open);
			toggle.setAttribute("aria-expanded", open ? "true" : "false");
		};

		toggle.addEventListener("click", () => {
			setOpen(!sidebar.classList.contains("is-open"));
		});

		if (logoutTrigger && logoutDialog) {
			logoutTrigger.addEventListener("click", (event) => {
				event.preventDefault();
				if (!logoutDialog.open) logoutDialog.showModal();
			});

			logoutCancel?.addEventListener("click", () => logoutDialog.close());
			logoutDialog.addEventListener("click", (event) => {
				if (event.target === logoutDialog) logoutDialog.close();
			});
			logoutDialog.addEventListener("close", () => logoutTrigger.focus());
		}

		document.addEventListener("keydown", (e) => {
			if (e.key !== "Escape" || logoutDialog?.open) return;
			if (sidebar.classList.contains("is-open")) {
				setOpen(false);
				toggle.focus();
			}
		});
	});
}
